import React, { useEffect } from "react";
import { useGetVideosQuery } from "../../../features/videos/videosApi";
import { useCreateQuizMutation } from "../../../features/quizzes/quizzesApi";
import { useNavigate } from "react-router-dom";

const intialState = [
  {
    id: 1,
    option: "",
    isCorrect: false,
  },
  {
    id: 2,
    option: "",
    isCorrect: false,
  },
  {
    id: 3,
    option: "",
    isCorrect: false,
  },
  {
    id: 4,
    option: "",
    isCorrect: false,
  },
];

const AddQuiz = () => {
  const {
    data: videos,
    isError: videoError,
    isLoading: videoLoading,
  } = useGetVideosQuery();

  const [addQuiz, { isSuccess: isQuizAddSuccess }] = useCreateQuizMutation();

  const [questionName, setQuestionName] = React.useState("");
  const [videoId, setVideoId] = React.useState(1);
  const [questionOptions, setQuestionOptions] = React.useState(intialState);

  const handleQuestionOptionChange = (e, id) => {
    const { value, type } = e.target;

    setQuestionOptions((prev) => {
      return prev.map((option) => {
        if (option.id === id) {
          if (type === "checkbox") {
            return {
              ...option,
              isCorrect: !option.isCorrect,
            };
          } else {
            return {
              ...option,
              option: value,
            };
          }
        }
        return option;
      });
    });
  };

  const handleAddQuiz = (e) => {
    e.preventDefault();
    const video_title = videos?.find(
      (video) => video?.id === Number(videoId)
    ).title;
    const quiz = {
      question: questionName,
      video_id: videoId,
      video_title,
      options: questionOptions,
    };
    addQuiz(quiz);
  };

  const navigate = useNavigate();

  useEffect(() => {
    if (isQuizAddSuccess) {
      navigate("/admin/quizzes");
    }
  }, [navigate, isQuizAddSuccess]);

  let content = null;
  if (videoLoading) {
    content = <div className="text-white">Loading...</div>;
  }
  if (!videoLoading && videoError) {
    content = <div className="text-white">Error</div>;
  }
  if (!videoLoading && !videoError && videos.length === 0) {
    content = <div className="text-white">No videos found</div>;
  }
  if (!videoLoading && !videoError && videos.length > 0) {
    content = videos.map((video) => {
      return (
        <option
          selected={video.id === videoId}
          key={video.id}
          value={video.id}
          className="text-white bg-[#080E1B]"
        >
          ${video.title}
        </option>
      );
    });
  }

  return (
    <div className="mx-auto max-w-5xl px-5 lg:px-20">
      <form onSubmit={handleAddQuiz} className="px-3 py-8 bg-opacity-10">
        <div className="flex flex-col gap-y-2">
          <label
            htmlFor="question"
            className="text-white text-left mb-3 font-semibold"
          >
            Question Name
          </label>
          <input
            required
            id="question"
            placeholder="Enter question's title"
            className="input input-bordered input-primary w-full text-white"
            onChange={(e) => setQuestionName(e.target.value)}
            value={questionName}
          />
          <label
            htmlFor="option_1"
            className="text-white text-left my-3 font-semibold"
          >
            Select the video to add quiz to
          </label>
          <select
            id="select_video"
            className="select disabled:text-[#9CA3AF] select-primary w-full text-white"
            onChange={(e) => setVideoId(e.target.value)}
          >
            <option disabled selected className="text-[#9CA3AF] bg-[#080E1B]">
              Select a video to add assignment to
            </option>
            {content}
          </select>
          <div className="flex items-center gap-x-4 my-3">
            <div className="basis-[85%] flex flex-col gap-y-3">
              <label
                htmlFor="option_1"
                className="text-white text-left font-semibold"
              >
                Quiz Option 1
              </label>
              <input
                required
                id="option_1"
                placeholder="Enter your quiz option #1"
                className="input input-bordered input-primary w-full text-white"
                value={questionOptions[0].option}
                onChange={(e) => handleQuestionOptionChange(e, 1)}
              />
            </div>
            <div className="basis-[15%] flex flex-col">
              <div className="form-control">
                <label className="label cursor-pointer flex flex-col gap-y-4 items-center">
                  <span className="label-text font-bold text-base">True</span>
                  <input
                    type="checkbox"
                    checked={questionOptions[0].isCorrect}
                    className="checkbox checkbox-primary checked:bg-indigo-600"
                    onChange={(e) => handleQuestionOptionChange(e, 1)}
                  />
                </label>
              </div>
            </div>
          </div>
          <div className="flex items-center gap-x-4 my-3">
            <div className="basis-[85%] flex flex-col gap-y-3">
              <label
                htmlFor="option_2"
                className="text-white text-left font-semibold"
              >
                Quiz Option 2
              </label>
              <input
                required
                id="option_2"
                placeholder="Enter your quiz option #2"
                className="input input-bordered input-primary w-full text-white"
                value={questionOptions[1].option}
                onChange={(e) => handleQuestionOptionChange(e, 2)}
              />
            </div>
            <div className="basis-[15%] flex flex-col">
              <div className="form-control">
                <label className="label cursor-pointer flex flex-col gap-y-4 items-center">
                  <span className="label-text font-bold text-base">True</span>
                  <input
                    type="checkbox"
                    checked={questionOptions[1].isCorrect}
                    className="checkbox checkbox-primary checked:bg-indigo-600"
                    onChange={(e) => handleQuestionOptionChange(e, 2)}
                  />
                </label>
              </div>
            </div>
          </div>
          <div className="flex items-center gap-x-4 my-3">
            <div className="basis-[85%] flex flex-col gap-y-3">
              <label
                htmlFor="option_3"
                className="text-white text-left font-semibold"
              >
                Quiz Option 3
              </label>
              <input
                required
                id="option_3"
                placeholder="Enter your quiz option #3"
                className="input input-bordered input-primary w-full text-white"
                value={questionOptions[2].option}
                onChange={(e) => handleQuestionOptionChange(e, 3)}
              />
            </div>
            <div className="basis-[15%] flex flex-col">
              <div className="form-control">
                <label className="label cursor-pointer flex flex-col gap-y-4 items-center">
                  <span className="label-text font-bold text-base">True</span>
                  <input
                    type="checkbox"
                    checked={questionOptions[2].isCorrect}
                    className="checkbox checkbox-primary checked:bg-indigo-600"
                    onChange={(e) => handleQuestionOptionChange(e, 3)}
                  />
                </label>
              </div>
            </div>
          </div>
          <div className="flex items-center gap-x-4 my-3">
            <div className="basis-[85%] flex flex-col gap-y-3">
              <label
                htmlFor="option_4"
                className="text-white text-left font-semibold"
              >
                Quiz Option 4
              </label>
              <input
                required
                id="option_4"
                placeholder="Enter your quiz option #4"
                className="input input-bordered input-primary w-full text-white"
                value={questionOptions[3].option}
                onChange={(e) => handleQuestionOptionChange(e, 4)}
              />
            </div>
            <div className="basis-[15%] flex flex-col">
              <div className="form-control">
                <label className="label cursor-pointer flex flex-col gap-y-4 items-center">
                  <span className="label-text font-bold text-base">True</span>
                  <input
                    type="checkbox"
                    checked={questionOptions[3].isCorrect}
                    className="checkbox checkbox-primary checked:bg-indigo-600"
                    onChange={(e) => handleQuestionOptionChange(e, 4)}
                  />
                </label>
              </div>
            </div>
          </div>
        </div>
        <button
          className="btn btn-secondary mt-6 bg-indigo-600 border-indigo-600"
          type="submit"
        >
          Add Question
        </button>
      </form>
    </div>
  );
};

export default AddQuiz;
